export const FETCH_TRANSACTIONS_INIT = 'SHOP::FETCH_TRANSACTIONS_INIT';
export const FETCH_TRANSACTIONS_SUCCESS = 'SHOP::FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'SHOP::FETCH_TRANSACTIONS_ERROR';
export const SET_STATE = 'SHOP::SET_STATE_TRANSACTIONS';